import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon, IconDefinition } from '@sorare/core/src/atoms/icons';
import { BodyM, HeadlineXL } from '@sorare/core/src/atoms/typography';
import { DecoratedRow } from '@sorare/core/src/components/marketing/DecoratedRow';
import { Romie20 } from '@sorare/core/src/components/marketing/typography';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { resinsurances } from './data';

const Item = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--unit);
  @media ${tabletAndAbove} {
    width: 25%;
  }
`;

type Resinsurance = {
  icon: IconDefinition;
  title: ReactNode;
  subtitle: ReactNode;
};

type ResinsuranceItemProps = {
  resinsurance: Resinsurance;
};
const ResinsuranceItem = ({
  resinsurance: { icon, title, subtitle },
}: ResinsuranceItemProps) => (
  <Item>
    <HeadlineXL as="h2">
      <FontAwesomeIcon icon={icon} size="lg" color="var(--c-pink-600)" />
    </HeadlineXL>
    <Romie20 color="var(--c-white)">{title}</Romie20>
    <BodyM color="var(--c-nd-400-opaque)">{subtitle}</BodyM>
  </Item>
);

export const Resinsurance = () => {
  return (
    <DecoratedRow
      title={
        <FormattedMessage
          id="AffiliateProgram.reinsurance.why.title"
          defaultMessage="The affiliate program"
        />
      }
      decorationText={
        <FormattedMessage
          id="AffiliateProgram.reinsurance.why"
          defaultMessage="Why ?"
        />
      }
      items={resinsurances.map((resinsurance, key) => (
        // eslint-disable-next-line react/no-array-index-key
        <ResinsuranceItem key={key} resinsurance={resinsurance} />
      ))}
    />
  );
};
